import React, { useCallback, useMemo, useRef, useState } from 'react';
import { SelectInput, TextInput, Unform, MaskInput, Icon } from 'components';
import { Box, Flex, Grid } from '@chakra-ui/layout';
import { RouteComponentProps } from 'react-router';
import { FormHandles } from '@unform/core';
import { debounce } from 'utils/debounce';
import { objToQuery, queryToObj } from 'utils/query';
import { routePaths } from 'constants/routes';
import { avaliations } from 'constants/avaliations';
import { Container, DownloadBtn } from './styles';
import { openNotification } from 'utils/notification';
import { checkPermission } from 'utils/authentication';
import { getMyAvaliationExportExcel } from 'services/myAvaliations';

interface IFormData {
  identificacao: string;
  formId: number;
}

interface IProps {
  history: RouteComponentProps['history'];
}

const FiltersHeader: React.FC<IProps> = ({ history }) => {
  const formRef = useRef<FormHandles>(null);
  const [dateRangeError, setDateRangeError] = useState<boolean>(false);
  const [isloading, setisloading] = useState<boolean>(false);

  const { formId, identificacao } = useMemo(() => {
    return queryToObj(history.location.search) as {
      formId?: string;
      identificacao?: string;
    };
  }, [history.location.search]);

  const handleSearch = useCallback(
    debounce(() => {
      const formData = formRef.current?.getData() as IFormData;

      const query = objToQuery({ ...formData, page: 0 });
      if (formData.formId) {
        history.replace(`${routePaths.myAvaliations}?${query}`);
      } else {
        formRef.current?.setFieldValue('formId', 5);
      }
    }, 600),
    [],
  );

  const defaultValue = useMemo(
    () => ({
      formId: formId || 5,
      identificacao,
    }),
    [formId],
  );

  console.log(defaultValue);

  const handleDownloadReport = async (): Promise<void> => {
    setisloading(true);
    const searchData = history.location.search.replace('page=0&', '');

    try {
      const { data: res } = await getMyAvaliationExportExcel(searchData);
      const url = window.URL.createObjectURL(new Blob([res]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'ropa.xlsx');
      document.body.appendChild(link);
      link.click();

      window.URL.revokeObjectURL(url);
      document.body.removeChild(link);
      // const { data: res } = await generateReportSimulatedFines(searchData);
      // const url = window.URL.createObjectURL(new Blob([res]));
      // const link = document.createElement('a');
      // link.href = url;
      // link.setAttribute('download', 'relatorio.xlsx');
      // document.body.appendChild(link);
      // link.click();
      // window.URL.revokeObjectURL(url);
      // document.body.removeChild(link);
    } catch (err: any) {
      if (err?.message.includes('400')) {
        openNotification('Não há simulações para o período informado.', 'error');
      }
    } finally {
      setisloading(false);
    }
  };

  return (
    <Unform initialData={defaultValue} formRef={formRef}>
      <Flex direction="column" mb="1rem" gridGap="0.5rem">
        <Container>
          {checkPermission({ onlyAdmin: true }) && Number(defaultValue.formId) === 5 ? (
            <Grid gridGap="1rem" gridTemplateColumns="2fr 1fr 1fr 0.1fr" width="100%">
              <SelectInput
                name="formId"
                isRequired
                optionValue="value"
                optionLabel="label"
                options={avaliations}
                onInput={handleSearch}
              />
              <MaskInput
                leftIcon="calendar"
                name="periodoInicial"
                mask="period"
                placeholder="Período inicial ___/___"
                notErrorMargin
                parseDate
                onChange={debounce(handleSearch, 1000)}
                hasError={dateRangeError}
              />
              <MaskInput
                placeholder="Período final  ___/___"
                leftIcon="calendar"
                name="periodoFinal"
                mask="period"
                notErrorMargin
                parseDate
                onChange={debounce(handleSearch, 1000)}
                hasError={dateRangeError}
              />

              <DownloadBtn
                onClick={() => handleDownloadReport()}
                type="button"
                variant="secondary"
                outline
                isLoading={isloading}
              >
                <Icon name="download" size={1.3} />
                <p>Relatório</p>
              </DownloadBtn>
              <TextInput
                width="100%"
                name="identificacao"
                notErrorMargin
                backgroundColor="#fff"
                leftIcon={{ name: 'search', color: 1100 }}
                placeholder="Buscar por identificação, criado por..."
                onInput={handleSearch}
              />
            </Grid>
          ) : (
            <>
              <TextInput
                width="100%"
                name="identificacao"
                notErrorMargin
                backgroundColor="#fff"
                leftIcon={{ name: 'search', color: 1100 }}
                placeholder="Buscar por identificação, criado por..."
                onInput={handleSearch}
              />
              <SelectInput
                name="formId"
                isRequired
                optionValue="value"
                optionLabel="label"
                options={avaliations}
                onInput={handleSearch}
              />
            </>
          )}
        </Container>

        <Box />
      </Flex>
    </Unform>
  );
};

export default FiltersHeader;
